<template>
    <div
            v-closable="{
              exclude : [],
              handler: 'closeDropdown'
            }"
            class="dropdown">
        <span v-for="menu in externalMenus" :key="menu.title">
            <button @click.prevent.stop="menu.action">
                <i v-if="menu.iconClass" :class="['fas', menu.iconClass]" :disabled="menu.disabled"></i>
            </button>
        </span>
        <div :class="['expander', {'expanded':expanded}]" v-if="internalMenus.length > 0">
            <button @click.prevent.stop="expanded=!expanded">
                <i class='fas fa-ellipsis-v'></i>
            </button>
            <div class="sub-menu">
                <ul class="sub-menu-container">
                    <template v-for="(menu, index) in internalMenus">
                        <b-dropdown-divider v-if="menu.isDivider"
                                            :key="`divider-${menu.title}-${index}`"></b-dropdown-divider>
                        <b-dropdown-item v-else @click.prevent.stop="menu.action" :key="`item-${menu.title}-${index}`">
                            <!-- <i v-if="menu.iconClass" :class="['fas', menu.iconClass]" :disabled="menu.disabled"></i> -->
                            {{menu.title}}
                        </b-dropdown-item>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import '@/directive/closable'
    export default {
        name: "DropDownMenu",
        props: {
            menus: Array
        },

        data() {
            return {expanded: false}
        },
        computed: {
            externalMenus: function () {
                if (!this.menus) return [];
                return this.menus.filter(itm => itm.external);
            },
            internalMenus: function () {
                if (!this.menus) return [];
                return this.menus.filter(itm => !itm.external);
            }
        },
        methods: {
            closeDropdown(){
                this.expanded = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    div.expander {
        display: inline-block;
        position: relative;
    }

    div.expander > button {
        background: transparent;
        color: gray;
    }

    .sub-menu-container {
        padding: .5rem 0;
        list-style: none;
        border-radius: .25rem;
        box-shadow: 0 0 15px 1px rgba(69, 65, 78, .2);
        background: white;
        font-size: 1rem;
    }

    div .expander div.sub-menu {
        position: absolute;
        right: 0px;
        top: 100%;
        display: none;
        height: auto;
        transition: all 0.3s ease-out;
        z-index: 1000;
    }

    .dropdown-item i {
        margin: 5px 10px;
    }

    div.expander.expanded div.sub-menu {
        display: inline-block;
        height: 0px;
    }

    div .expander div.sub-menu a {
        background: white;
    }

    .dropdown button {
        border-radius: 0;
    }

    .dropdown span:first-child button {
        border-radius: 3px 0 0 3px;
    }

</style>


<style lang="scss">
    .dropdown {
        .sub-menu-container {
            background: white;
            padding: 0;
            list-style: none;
            border-radius: 3px;
            box-shadow: 0 0 15px 1px rgba(69, 65, 78, .2);

            li {
                a {
                    padding: .7rem 1.2rem;
                    color: #575962;
                    font-size: 13px;
                    line-height: 19.5px;
                }
            }
        }
    }
</style>
